<script>
    export default {
        name: 'FeaturedDiscount',

        props: {
            featuredDiscount: Object,
        },

        computed: {
            value() {
                if (this.featuredDiscount.discount.promo_id) {
                    switch (this.featuredDiscount.discount.promo.id_tipo_oferta) {
                        case 14:
                            return `${parseInt(
                                this.featuredDiscount.discount.promo.porcentagens[0]
                            )}% OFF`;
                        case 25:
                            return this.$f.formatMoney(
                                this.featuredDiscount.discount.promo.preco_oferta
                            );
                    }
                }

                switch (this.featuredDiscount.discount.type_id) {
                    case 1:
                        return `${parseInt(this.featuredDiscount.discount.value)}% OFF`;
                    case 2:
                        return this.$f.formatMoney(this.featuredDiscount.discount.value) + ' OFF';
                }
                return null;
            },
        },
    };
</script>